import { IxFab } from './IxFab.js';

window.customElements.define('ix-fab', IxFab);
